export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox'
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 85,
    slots: {
      default: 'opt'
    }
  },
  {
    field: 'pickDatetime',
    title: '提货时间',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'custName',
    title: '客户',
    headerAlign: 'center',
    fixed: 'left',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'v_transportMode',
    title: '运输模式',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'bizBillNo',
    title: 'ERP/WMS单号',
    headerAlign: 'center',
    fixed: 'left',
    width: 125,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'dispatchOrderNo',
    title: '调度订单编号',
    align: 'center',
    fixed: 'left',
    width: 180,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'orderSoNo',
    title: '销售订单号',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {default: 'orderso'}
  },
  {
    field: 'orderNo',
    title: '原订单编号',
    align: 'center',
    width: 150,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'orderNo',
    },
  },
  {
    field: 'waybillNo',
    title: '运单编号',
    align: 'center',
    width: 150,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'v_bizStatus',
    title: '运输状态',
    headerAlign: 'center',
    align: 'center',
    width: 90,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'v_isAbnormal',
    title: '异常',
    headerAlign: 'center',
    align: 'center',
    width: 50,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveDatetime',
    title: '送达时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'podDatetime',
    title: '回单时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'orgName',
    title: '组织机构',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'carrierName',
    title: '承运商名称',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'vehicleNo',
    title: '车牌号',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'driverName',
    title: '司机姓名',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'driverMobile',
    title: '司机手机号',
    headerAlign: 'center',
    align: 'center',
    width: 115,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'assistant',
    title: '跟车员',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'assistantMobile',
    title: '跟车员手机',
    headerAlign: 'center',
    align: 'center',
    width: 115,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'orderDate',
    title: '托运日期',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'orderCreateTime',
    title: '订单创建时间',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'orderCreateByName',
    title: '订单创建人',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'v_orderType',
    title: '订单类型',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'v_bizType',
    title: '业务类型',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'v_vehicleModel',
    title: '车型需求',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'v_vehicleLength',
    title: '车长需求',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'vehicleLoad',
    title: '载重(吨)',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'vehicleVolume',
    title: '载方(m³)',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totQty',
    title: '总件数',
    headerAlign: 'center',
    align: 'center',
    width: 70,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totInWeight',
    title: '总收入重量kg',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totInVolume',
    title: '总收入体积m³',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totPayWeight',
    title: '总支出重量kg',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totPayVolume',
    title: '总支出体积m³',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totValue',
    title: '总货值',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickDatetimeBegin',
    title: '预计提货时间开始',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickDatetimeEnd',
    title: '预计提货时间截止',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveDatetimeBegin',
    title: '预计收货时间开始',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveDatetimeEnd',
    title: '预计收货时间截止',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'transportHours',
    title: '运输时效',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },

  {
    field: 'pickupPointName',
    title: '发货方',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupProvinceName',
    title: '发货省份',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupCityName',
    title: '发货城市',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupDistrictName',
    title: '发货区县',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupAddress',
    title: '发货地址',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupContactName',
    title: '发货联系人',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupContactMobile',
    title: '发货手机号',
    headerAlign: 'center',
    align: 'center',
    width: 115,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupContactPhone',
    title: '发货联系电话',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupContactEmail',
    title: '发货联系邮件',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupRemark',
    title: '发货备注',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receivePointName',
    title: '收货方',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveProvinceName',
    title: '收货省份',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveCityName',
    title: '收货城市',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveDistrictName',
    title: '收货区县',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveAddress',
    title: '收货地址',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveContactName',
    title: '收货联系人',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveContactMobile',
    title: '收货手机号',
    headerAlign: 'center',
    align: 'center',
    width: 115,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveContactPhone',
    title: '收货电话',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveContactEmail',
    title: '收货邮件',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveRemark',
    title: '收货备注',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'v_chargeUnit',
    title: '计费单位',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'basePrice',
    title: '运费单价',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'chargeQty',
    title: '计费数量',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'payFreight',
    title: '应付运费合计',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'payFee',
    title: '应付费用合计',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'payAmount',
    title: '应付合计',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'contractFreight',
    title: '合同运费合计',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'contractFee',
    title: '合同费用合计',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'contractAmount',
    title: '合同应付合计',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  }
]
